module.exports = __webpack_public_path__ + "static/media/icon-piece7-11.cd3829b9.png";